import firebase from "firebase/compat";
import { curry } from "ramda";

import { ApplyTimestampType } from "../types/firebase.types";

const applyTimestamps = curry((type: ApplyTimestampType, data: Record<string, any>) => {
  if (type === ApplyTimestampType.update) {
    return {
      ...data,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    };
  } else {
    return {
      ...data,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    };
  }
});

export const applyCreateTimestamp = applyTimestamps(ApplyTimestampType.create);
export const applyUpdateTimestamp = applyTimestamps(ApplyTimestampType.update);

export const serverTimestamp = () => firebase.firestore.FieldValue.serverTimestamp();
export const generateTimestamp = (date: Date) => new firebase.firestore.Timestamp(date.valueOf() / 1000, 0);
